'use client'

import {
  Box,
  Button,
  Container,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import NextLink from "next/link";
import { MyPaper } from "@/styles/theme";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LanguageChanger from "../Common/LanugageChanger";
import Vote9Logo from "@/components/Common/Vote9Logo";


export default function SelectElection(): JSX.Element {
  const [electionid, setElectionId] = useState<string>("");
  const [manageDialogOpen, setManageDialogOpen] = useState(false);
  const { t } = useTranslation();
  const trimmedElectionId = electionid.trim();
  const electionHref = trimmedElectionId ? `/election/${trimmedElectionId}` : "/election";
  const manageHref = trimmedElectionId ? `/manage/${trimmedElectionId}` : "#";

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <MyPaper sx={{ position: "relative" }}>
        <Box
          sx={{
            position: { xs: "static", lg: "absolute" },
            top: { lg: 0 },
            right: { lg: 0 },
            width: { xs: "100%", lg: "auto" },
            display: "flex",
            justifyContent: { xs: "center", lg: "flex-end" },
            mb: { xs: 0.5, lg: 0 },
            zIndex: 1,
          }}
        >
          <LanguageChanger />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", textAlign: "center", pt: 0 }}>
          <Vote9Logo width={150} height={75} />
        </Box>
        <Grid2 container justifyContent={"flex-start"}>
          <Typography component="div" variant="h5">
            {t('election')}
          </Typography>
        </Grid2>
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          id="electionid"
          label={t('election_id')}
          // name="electionid"
          autoFocus
          onChange={(e) => {
            setElectionId(e.target.value);
          }}
        />
        <Button
          fullWidth
          href={electionHref}
          variant="contained"
          color="primary"
          size="large"
          sx={{ mt: 2, mb: 1 }}
          LinkComponent={NextLink}
        >
          {t('begin_election')}
        </Button>
        <Grid2 container justifyContent="center" alignItems="center" spacing={1.5} sx={{ mt: 0.75, mb: 1 }}>
          <Grid2 size={{ xs: 12, sm: "auto" }} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Link
              href={manageHref}
              component={NextLink}
              variant="body2"
              color="primary"
              sx={{
                textDecoration: "none",
                borderRadius: 1,
                px: 1.5,
                py: 0.65,
                border: "1px solid",
                borderColor: "divider",
                display: 'inline-flex',
                justifyContent: 'center',
                width: { xs: '100%', sm: 'auto' },
                minWidth: { xs: 240, sm: 200 },
                transition: "background-color 120ms ease, border-color 120ms ease",
                "&:hover": {
                  bgcolor: "action.hover",
                  borderColor: "primary.light",
                },
                "&:focus-visible": {
                  outline: "2px solid",
                  outlineColor: "primary.main",
                  outlineOffset: 1,
                },
              }}
              onClick={(e) => {
                if (!trimmedElectionId) {
                  e.preventDefault();
                  setManageDialogOpen(true);
                }
              }}
            >
              {t('manage_election')}
            </Link>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: "auto" }} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Link
              href="create"
              component={NextLink}
              variant="body2"
              color="primary"
              sx={{
                textDecoration: "none",
                borderRadius: 1,
                px: 1.5,
                py: 0.65,
                border: "1px solid",
                borderColor: "divider",
                display: 'inline-flex',
                justifyContent: 'center',
                width: { xs: '100%', sm: 'auto' },
                minWidth: { xs: 240, sm: 200 },
                transition: "background-color 120ms ease, border-color 120ms ease",
                "&:hover": {
                  bgcolor: "action.hover",
                  borderColor: "primary.light",
                },
                "&:focus-visible": {
                  outline: "2px solid",
                  outlineColor: "primary.main",
                  outlineOffset: 1,
                },
              }}
            >
              {t('create_election')}
            </Link>
          </Grid2>
        </Grid2>

        <Dialog open={manageDialogOpen} onClose={() => setManageDialogOpen(false)}>
          <DialogTitle>{t('manage_election')}</DialogTitle>
          <DialogContent>
            <DialogContentText>{t('home:enter_election_id_first')}</DialogContentText>
            <DialogContentText sx={{ mt: 1 }}>
              {t('home:enter_election_id_first_help')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setManageDialogOpen(false)} autoFocus>
              {t('common:ok')}
            </Button>
          </DialogActions>
        </Dialog>
      </MyPaper>
    </Container >
  );
}
